import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '@shared/components/button/button.component';
import { ModalService } from '@shared/components/modal-list/modal-list.service';
import { CartService } from '@b2b/features/cart/core/cart.service';
import { CartList } from '@b2b/features/cart/utilities/cart-list-model';
import { TranslateModule } from '@ngx-translate/core';
import { distinctUntilChanged, map, take } from 'rxjs';

@Component({
  selector: 'select-cart-modal',
  imports: [CommonModule, TranslateModule, ButtonComponent],
  templateUrl: './select-cart-modal.component.html',
  styleUrl: './select-cart-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectCartModalComponent {
  cart$ = this.modalService.getActiveModal().pipe(
    map(modal => modal?.data),
    distinctUntilChanged(),
  );

  constructor(
    private modalService: ModalService<CartList>,
    private cartService: CartService,
    private router: Router,
  ) {}

  onCancel() {
    this.modalService.skip();
  }

  onSubmit() {
    this.cart$.pipe(take(1)).subscribe(cart => {
      this.cartService.fetchCart(cart?.code || this.cartService.getCartID());
      this.cartService.setCartID(cart?.code || '');
      this.router.navigate(['/carrinho']);
    });

    this.modalService.skip();
  }
}
